<!-- CONTENEDOR FIJO ABAJO-DERECHA -->
<div class="fc" [class.open]="open">

  <!-- Botón flotante -->
  <button class="fc__btn" type="button" (click)="toggle()" aria-haspopup="dialog">
    <i class="bi bi-chat"></i>
    {{ t('chat.button') }}
  </button>

  <!-- Panel del asesor (aparece encima del botón) -->
  <div *ngIf="open" class="fc__panel" role="dialog" [attr.aria-label]="t('chat.dialogAria')">
    <header class="fc__head">
      {{ t('chat.header') }}
      <button type="button" class="fc__close" (click)="close()" [attr.aria-label]="t('chat.close')">✕</button>
    </header>

    <div class="fc__body">
      <!-- Avatar con estado superpuesto abajo-derecha -->
      <div class="fc__avatar-wrap" [attr.aria-label]="online ? t('chat.onlineLabel') : t('chat.busyLabel')">
        <img class="fc__avatar" [src]="avatarUrl || 'assets/footer/agente.png'" alt="Asesor">
        <span class="fc__presence" [class.off]="!online" [title]="online ? t('chat.online') : t('chat.busy')"></span>
      </div>

      <div class="fc__info">
        <div class="fc__role">{{ advisorRole }}</div>
        <div class="fc__name">{{ advisorName }}</div>
      </div>
    </div>

    <div class="fc__actions">
      <button type="button" class="fc__wa" (click)="openWhatsApp()">
        💬 {{ t('chat.whatsapp') }}
      </button>
    </div>

    <!-- flecha que apunta al botón -->
    <span class="fc__caret" aria-hidden="true"></span>
  </div>
</div>
